import { Component, OnInit } from '@angular/core';
import { ApiProviderService } from 'src/app/services/api-provider.service';

@Component({
  selector: 'unkown-route-screen',
  templateUrl: './unkown-route-screen.component.html',
  styleUrls: ['./unkown-route-screen.component.css']
})
export class UnkownRouteScreenComponent implements OnInit {

  constructor(private apiRef: ApiProviderService) { }

  ngOnInit(): void {
  }

  goToHome(){
    window.location.href = this.apiRef.vDir;
  }

}
